{
  "connection": {
    "welcomeMessage": "Willkommen, {{firstName}}!",
    "description": "Richten Sie Chirpee in 15 Minuten ein und beginnen Sie, Feedback Ihrer Mitarbeitenden in Echtzeit zu sammeln.",
    "pill": {
      "setupNow": "Jetzt einrichten",
      "connected": "Verbunden",
      "completed": "Abgeschlossen"
    },
    "options": {
      "ssoConnected": {
        "title": "SSO verbinden",
        "description": "Einmalanmeldung einrichten, um den Zugriff für Ihre Organisation zu verwalten.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Verwalten"
      },
      "hrisConnected": {
        "title": "Organigramm verbinden",
        "description": "Importieren Sie Ihre Organisationsstruktur für automatisierte Workflows.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Konfigurieren"
      },
      "messagingConnected": {
        "title": "Kommunikationstool verbinden",
        "description": "Sammeln Sie Feedback über die Kommunikationsplattformen Ihres Teams.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Konfigurieren"
      },
      "billingSetup": {
        "title": "Abrechnung einrichten",
        "description": "Fügen Sie Ihre Zahlungsinformationen hinzu und wählen Sie einen passenden Plan.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Konfigurieren"
      },
      "branding": {
        "title": "Unternehmensbranding",
        "description": "Passen Sie das Branding Ihres Unternehmens für ein konsistentes Erlebnis an.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Konfigurieren"
      }
    }
  },
  "billing": {
    "backToGettingStarted": "Zurück zu Erste Schritte",
    "title": "Abrechnung einrichten",
    "description": "Wählen Sie die Abrechnungsoption, die am besten zu Ihrer Organisation passt.",
    "currencyLabel": "Währung:",
    "currencyPlaceholder": "Währung",
    "taxDisclaimer": "Alle Preise verstehen sich zuzüglich anfallender Steuern.",
    "freeTrial": {
      "title": "Starten Sie mit einer 30-tägigen kostenlosen Testphase",
      "description": "Bis zum Ende Ihrer Testphase fallen keine Kosten an. Sammeln Sie den ersten Monat an Mitarbeiter-Insights völlig kostenlos."
    },
    "employeeCount": {
      "title": "Mitarbeiteranzahl",
      "hrisConnected": "HRIS verbunden",
      "pendingHrisSync": "HRIS-Synchronisierung ausstehend",
      "readonlyCount": "{{count}} Mitarbeitende",
      "description": "Die Anzahl der Mitarbeiterplätze ist dynamisch und basiert auf der Anzahl der aktiven Benutzer, die aus Ihrem HRIS-System synchronisiert wurden und Fragen erhalten."
    },
    "plans": {
      "recommended": "Empfohlen",
      "perEmployeeMonth": "pro Mitarbeitendem / Monat",
      "employeeCountFormula": "{{count}} Mitarbeitende",
      "monthlyTotal": "Monatliche Summe",
      "perMonth": "/ Monat",
      "launchingCheckout": "Checkout wird gestartet...",
      "monthly": {
        "title": "Monatsplan",
        "subtitle": "Monatliche Abrechnung",
        "cta": "Monatsplan auswählen"
      },
      "annual": {
        "title": "Jahresplan",
        "subtitle": "Jährliche Abrechnung",
        "cta": "Jahresplan auswählen",
        "savingsBadge": "{{percent}} % sparen",
        "savingsText": "Sparen Sie {{amount}}/Jahr mit {{count}} Mitarbeitenden"
      }
    },
    "features": {
      "title": "Alle Funktionen in beiden Plänen enthalten",
      "comingSoon": "Demnächst",
      "items": {
        "dailyQuestionDelivery": "Tägliche Fragenzustellung",
        "enterpriseSecurity": "Sicherheit auf Enterprise-Niveau",
        "slackTeamsIntegration": "Slack- & Teams-Integration",
        "analyticsDashboard": "Vollständiges Analyse-Dashboard",
        "teamInsights": "Unbegrenzte Team-Insights",
        "hrisIntegration": "HRIS-Integration",
        "dedicatedSupport": "Dedizierter Support",
        "surveyBuilder": "Umfrage-Builder"
      }
    },
    "socialProof": {
      "title": "Warum Organisationen kontinuierliches Feedback wählen",
      "cards": {
        "turnover": {
          "description": "Niedrigere Fluktuationsraten in Organisationen mit regelmäßigem Feedback",
          "source": "Gallup, 2023"
        },
        "managerEffectiveness": {
          "description": "Höhere Führungskräftewirksamkeit durch kontinuierliche Mitarbeiter-Insights",
          "source": "Harvard Business Review, 2022"
        },
        "profitMargins": {
          "description": "Höhere Gewinnmargen in Unternehmen mit kontinuierlichen Feedbacksystemen",
          "source": "PwC, 2023"
        }
      }
    },
    "invoiceFooter": "Benötigen Sie rechnungsbasierte Abrechnung? Kontaktieren Sie uns unter <supportLink>support@chirpee.co</supportLink>",
    "complete": {
      "title": "Zahlung einrichten",
      "description": "Ihre Zahlungseinrichtung wird bestätigt. Kehren Sie zu Erste Schritte zurück, um das Onboarding fortzusetzen."
    },
    "errors": {
      "chooseCurrency": "Wählen Sie eine Abrechnungswährung, bevor Sie fortfahren.",
      "stripeKeyMissing": "Der veröffentlichbare Stripe-Schlüssel ist nicht konfiguriert.",
      "checkoutStartFailed": "Checkout konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
      "setupLoadFailed": "Die Details zur Abrechnungseinrichtung konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "pricingUnavailable": "Preise sind für {{currency}} nicht verfügbar. Bitte wählen Sie eine andere Währung."
    }
  }
}
